import React from "react";
import "./style.scss";
import {useTranslation} from "react-i18next";
import BlockBtn from "../BlockBtn";
import crossImage from "../../images/icons/cross.png";

const ConfirmBox = ({
  title,
  text,
  close,
  performAction,
  disclaimertext,
  image,
}) => {
  const {t} = useTranslation();
  return (
    <div className="confirm-box-container">
      <div className="confirm-box-inner-container">
        {title ? (
          <div className={"confirm-box-title-div"}>
            <img
              className="grey-close-image"
              src={crossImage}
              alt="X"
              onClick={close}
            />
            <h4 className="confirm-box-title-text">{title}</h4>
          </div>
        ) : (
          ""
        )}
        {image ? (
          <img className="modal-image-tick" src={image} alt="tick" />
        ) : (
          ""
        )}
        <div className="confirm-box-text-container">
          {text.map((s) => (
            <div key={Math.random()}>
              <label className="confirm-box-text">{s}</label>
            </div>
          ))}
        </div>
        {performAction ? (
          <div className="confirm-box-double-btn-div">
            <BlockBtn
              name={"Si"}
              type={"primary"}
              handleClick={performAction}
              disabled={false}
            />
            <div className="add-space"> </div>
            <BlockBtn
              name={"No"}
              type={"secondary"}
              handleClick={close}
              disabled={false}
            />
          </div>
        ) : (
          <div className="confirm-box-single-btn-div">
            <BlockBtn name={"OK"} handleClick={close} disabled={false} />
          </div>
        )}
        {disclaimertext ? (
          <div className="confirm-box-text-container confirm-box-disclaimer-text">
            {disclaimertext}
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default ConfirmBox;
